import React, { useEffect } from "react";
import { useLocation, useNavigate, HashRouter, Routes, Route } from "react-router-dom";
import "./App.css";

// static pages
import Index from "./screens/cms/index";
import AboutItme from "./screens/static/aboutItme";
import AboutOrganizer from "./screens/static/aboutOrganizer";
import AmentiesLayout from "./screens/static/amentiesLayout";
import AssociatesPartners from "./screens/static/associatesPartners";
import Awards from "./screens/static/awards.js";
import Contact from "./screens/static/contact";
import CookiePolicy from "./screens/static/cookiePolicy";
import DaywiseItinerary from "./screens/static/daywiseItinerary";
import EDirectory from "./screens/static/eDirectory";
import ExhibitorList2026 from "./screens/static/exhibitorList2026";
import ExhibitorsList from "./screens/static/exhibitorsList";
import ExhibitorsTravelAssistance from "./screens/static/exhibitorsTravelAssistance";
import GlanceItme from "./screens/static/glanceItme";
import GoodwillMessage from "./screens/static/goodwillMessage";
import Index1 from "./screens/static/index1";
import IndexComingSoon from "./screens/static/indexComingSoon";
import IndexOfProduct from "./screens/static/indexOfProduct";
import IndustryInfo from "./screens/static/industryInfo";
import InvitationLetter from "./screens/static/invitationLetter";
import LegalStuff from "./screens/static/legalStuff";
import MediaCoverage from "./screens/static/mediaCoverage";
import MediaKit from "./screens/static/mediaKit";
import PastEvents from "./screens/static/pastEvents";
import PhotoGallery from "./screens/static/photoGallery";
import PressRelease from "./screens/static/pressRelease";
import PrivacyPolicy from "./screens/static/privacyPolicy";
import ProductLaunch from "./screens/static/productLaunch";
import ShuttleBusService from "./screens/static/shuttleBusService";
import TermsAndConditions from "./screens/static/termsAndConditions";
import UpcomingEvent from "./screens/static/upcomingEvent";
import TrafficePlanLayout from "./screens/static/trafficePlanLayout";
import VenueDetails from "./screens/static/venueDetails";
import VenueLayout from "./screens/static/venueLayout";
import VideoGallery from "./screens/static/videoGallery";
import VisitorGuide from "./screens/static/visitorGuide";
import VisitorPromotion from "./screens/static/visitorPromotion";
import VisitorTravelAssistance from "./screens/static/visitorTravelAssistance";
import WebAdvertisementBanner from "./screens/static/webAdvertisementBanner";

// CMS pages
import CmsHome from "./screens/cms/cmsHome.js";
import CmsHeaderMaster from "./screens/cms/cmsHeaderMaster.js";

// Auth pages
import Login from "./screens/user_login_auth/login.js";
import PageNotFound from "./screens/user_login_auth/pageNotFound.js";

function AppRoutes() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const storedUser = localStorage.getItem("isVerified");
    if (location.pathname.startsWith("/cms") && !storedUser) {
      navigate("/login");
    }
    if (!location.pathname.includes("/cms/manage")) {
      const disableRightClick = (e) => e.preventDefault();
      document.addEventListener("contextmenu", disableRightClick);

      const disableCopyCutPaste = (e) => e.preventDefault();
      document.addEventListener("copy", disableCopyCutPaste);
      document.addEventListener("cut", disableCopyCutPaste);
      document.addEventListener("paste", disableCopyCutPaste);

      const disableSelectStart = (e) => e.preventDefault();
      document.addEventListener("selectstart", disableSelectStart);

      const disableInspect = (e) => {
        if (
          e.key === "F12" ||
          (e.ctrlKey && e.shiftKey && (e.key === "I" || e.key === "i")) ||
          (e.ctrlKey && e.shiftKey && (e.key === "J" || e.key === "j")) ||
          (e.ctrlKey && e.key.toLowerCase() === "u") ||
          (e.ctrlKey && e.key.toLowerCase() === "s") ||
          (e.ctrlKey && e.key.toLowerCase() === "c") ||
          (e.ctrlKey && e.key.toLowerCase() === "p")
        ) {
          e.preventDefault();
        }
      };
      document.addEventListener("keydown", disableInspect);

      const checkDevTools = setInterval(() => {
        const element = new Image();
        Object.defineProperty(element, "id", {
          get: function () {
            window.location.replace("/");
          }
        });
      }, 1000);

      return () => {
        document.removeEventListener("contextmenu", disableRightClick);
        document.removeEventListener("copy", disableCopyCutPaste);
        document.removeEventListener("cut", disableCopyCutPaste);
        document.removeEventListener("paste", disableCopyCutPaste);
        document.removeEventListener("selectstart", disableSelectStart);
        document.removeEventListener("keydown", disableInspect);
        clearInterval(checkDevTools);
      };
    }

  }, [location, navigate]);


  return (
    <div className="App">
      <div className="auth-inner">
        <Routes>
          {/* public routes */}
          <Route exact path="/" element={<Index />} />
          <Route exact path="/:page" element={<Index />} />
          <Route exact path="/login" element={<Login />} />

          {/* CMS routes - protected */}
          <Route exact path="/cms/manage" element={<CmsHome />} />
          <Route exact path="/cms/manage/:page" element={<CmsHome />} />
          <Route exact path="/cms/header" element={<CmsHeaderMaster />} />

          {/* other static routes */}
          <Route exact path="/index" element={<Index />} />
          <Route exact path="/index1" element={<Index1 />} />
          <Route exact path="/AboutItme" element={<AboutItme />} />
          <Route exact path="/AboutOrganizer" element={<AboutOrganizer />} />
          <Route exact path="/AmentiesLayout" element={<AmentiesLayout />} />
          <Route exact path="/AssociatesPartners" element={<AssociatesPartners />} />
          <Route exact path="/Awards" element={<Awards />} />
          <Route exact path="/Contact" element={<Contact />} />
          <Route exact path="/CookiePolicy" element={<CookiePolicy />} />
          <Route exact path="/DaywiseItinerary" element={<DaywiseItinerary />} />
          <Route exact path="/EDirectory" element={<EDirectory />} />
          <Route exact path="/ExhibitorList2026" element={<ExhibitorList2026 />} />
          <Route exact path="/ExhibitorsList" element={<ExhibitorsList />} />
          <Route exact path="/ExhibitorsTravelAssistance" element={<ExhibitorsTravelAssistance />} />
          <Route exact path="/GlanceItme" element={<GlanceItme />} />
          <Route exact path="/GoodwillMessage" element={<GoodwillMessage />} />
          <Route exact path="/IndexComingSoon" element={<IndexComingSoon />} />
          <Route exact path="/IndexOfProduct" element={<IndexOfProduct />} />
          <Route exact path="/IndustryInfo" element={<IndustryInfo />} />
          <Route exact path="/InvitationLetter" element={<InvitationLetter />} />
          <Route exact path="/LegalStuff" element={<LegalStuff />} />
          <Route exact path="/MediaCoverage" element={<MediaCoverage />} />
          <Route exact path="/MediaKit" element={<MediaKit />} />
          <Route exact path="/PastEvents" element={<PastEvents />} />
          <Route exact path="/PhotoGallery" element={<PhotoGallery />} />
          <Route exact path="/PressRelease" element={<PressRelease />} />
          <Route exact path="/PrivacyPolicy" element={<PrivacyPolicy />} />
          <Route exact path="/ProductLaunch" element={<ProductLaunch />} />
          <Route exact path="/ShuttleBusService" element={<ShuttleBusService />} />
          <Route exact path="/TermsAndConditions" element={<TermsAndConditions />} />
          <Route exact path="/TrafficePlanLayout" element={<TrafficePlanLayout />} />
          <Route exact path="/UpcomingEvent" element={<UpcomingEvent />} />
          <Route exact path="/VenueDetails" element={<VenueDetails />} />
          <Route exact path="/VenueLayout" element={<VenueLayout />} />
          <Route exact path="/VideoGallery" element={<VideoGallery />} />
          <Route exact path="/VisitorGuide" element={<VisitorGuide />} />
          <Route exact path="/VisitorPromotion" element={<VisitorPromotion />} />
          <Route exact path="/VisitorTravelAssistance" element={<VisitorTravelAssistance />} />
          <Route exact path="/WebAdvertisementBanner" element={<WebAdvertisementBanner />} />

          {/* fallback */}
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </div>
    </div>
  );
}

function App() {
  return (
    <HashRouter>
      <AppRoutes />
    </HashRouter>
  );
}

export default App;
